import { featureFlagsType } from './feature-flags-types';

export function setFeatureFlags(name, value) {
	return {
		type: featureFlagsType,
		name,
		value,
	};
}
